import * as React from 'react'

function Copy(props: any) {
  return (
    <svg
      {...props}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width='12px'
      height='12px'
      x='0px'
      y='0px'
      viewBox='0 0 1000 1000'
      enableBackground='new 0 0 1000 1000'
    >
      <g>
        <g>
          <path d='M920,902.5v-595c0-4.7-1.7-8.8-5.2-12.3c-3.5-3.5-7.6-5.2-12.3-5.2h-595c-4.7,0-8.8,1.7-12.3,5.2s-5.2,7.6-5.2,12.3v595c0,4.7,1.7,8.8,5.2,12.3c3.5,3.5,7.6,5.2,12.3,5.2h595c4.7,0,8.8-1.7,12.3-5.2C918.3,911.3,920,907.2,920,902.5z M990,307.5v595c0,24.1-8.6,44.7-25.7,61.8c-17.1,17.1-37.7,25.7-61.8,25.7h-595c-24.1,0-44.7-8.6-61.8-25.7c-17.1-17.1-25.7-37.7-25.7-61.8v-595c0-24.1,8.6-44.7,25.7-61.8c17.1-17.1,37.7-25.7,61.8-25.7h595c24.1,0,44.7,8.6,61.8,25.7C981.4,262.8,990,283.4,990,307.5z M780,97.5V185h-70V97.5c0-4.7-1.7-8.8-5.2-12.3s-7.6-5.2-12.3-5.2h-595c-4.7,0-8.8,1.7-12.3,5.2S80,92.8,80,97.5v595c0,4.7,1.7,8.8,5.2,12.3c3.5,3.5,7.6,5.2,12.3,5.2H185v70H97.5c-24.1,0-44.7-8.6-61.8-25.7C18.6,737.2,10,716.6,10,692.5v-595c0-24.1,8.6-44.7,25.7-61.8C52.8,18.6,73.4,10,97.5,10h595c24.1,0,44.7,8.6,61.8,25.7C771.4,52.8,780,73.4,780,97.5L780,97.5z' />
        </g>
      </g>
    </svg>
  )
}

export default Copy



// WEBPACK FOOTER //
// ./src/components/icons/ui/Copy.tsx